import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative z-10 w-full max-w-sm mx-auto space-y-4 p-8 rounded shadow bg-white/10 backdrop-blur text-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-white"
}
const _hoisted_3 = {
  key: 1,
  class: "text-white"
}

import axios from "@/axiosInstance";
	import { setAuth } from "@/router";
	import { onMounted, ref } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import { useToast } from "vue-toast-notification";

	import bg from "@/assets/sfondo-bg-1.png"; // immagine

	
export default /*@__PURE__*/_defineComponent({
  __name: 'OauthSuccess',
  setup(__props) {

	const router = useRouter();
	const route = useRoute();
	const toast = useToast();

	const ready = ref(false);
	const user = ref("");

	onMounted(async () => {
		/* ①  prendo i dati utente (se il cookie è già valido) */
		try {
			const { data } = await axios.get("/auth/me", { withCredentials: true });
			user.value = data.username || data.email || "";
			setAuth(true);
			// toast.success(`Bentornato ${data.username || data.email}! Accesso con GitHub riuscito.`, { duration: 4000, position: "top-right" });
			ready.value = true;
		} catch (err) {
			console.error(err);
			ready.value = true;
			toast.error("Sessione non valida, per favore effettua di nuovo il login");
			setTimeout(() => router.replace({ name: "Auth" }), 2500);
		}

		/* ②  breve attesa e redirect */
		// setTimeout(() => router.replace({ name: "Dashboard" }), 3000); // 2 s

		// Mantieni il flag  ?auth=provider
		setTimeout(() => {
			router.replace({
				name: "Dashboard",
				query: { auth: route.query.auth }, // 👈  preserva il provider
			});
		}, 3000);
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "min-h-screen bg-no-repeat bg-center md:bg-right bg-cover relative flex items-center justify-start px-6",
    style: _normalizeStyle({ backgroundImage: `url(${_unref(bg)})` })
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-0 bg-black/60" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      (!ready.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Verifica dell’account in corso… "))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createTextVNode(" Benvenuto " + _toDisplayString(user.value) + "!", 1),
            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
            _cache[1] || (_cache[1] = _createTextVNode(" Verrai reindirizzato alla dashboard tra pochi secondi… ", -1))
          ]))
    ])
  ], 4))
}
}

})